import { render } from "./CurrentFundPrices.vue?vue&type=template&id=49459d07"
import script from "./CurrentFundPrices.vue?vue&type=script&lang=js"
export * from "./CurrentFundPrices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__